module.exports = __webpack_public_path__ + "img/meme_20.4abb278b.jpg";